<div #modal [attr.id]="id" [class]="'modal fade ' + 'modal-'+size" aria-labelledby="title-id" tabindex="-1"
  [attr.data-bs-backdrop]="backdropStatic ? 'static' : 'true'" [attr.data-bs-keyboard]="!backdropStatic">
  <div [class]="'modal-dialog modal-dialog-centered modal-dialog-scrollable ' + size">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="title-id" class="modal-title">
          <ng-content select="[title]"></ng-content>
        </h4>
        @if(!backdropStatic){
        <button type="button" class="btn btn-light btn-rounded" data-bs-dismiss="modal">
          <img src="assets/icons/close.svg" alt="Close modal">
        </button>
        }
      </div>
      <div class="modal-body">
        <ng-content select="[body]"></ng-content>
      </div>
      <div class="modal-footer">
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>
  </div>
</div>
